/* eslint-disable @typescript-eslint/no-explicit-any */
import { message } from 'ant-design-vue';

export interface ValidateRuleItemI {
  reg?: RegExp;
  min?: number;
  max?: number;
  message: string;
  required?: boolean;
}

export interface ValidateRuleI {
  [key: string]: ValidateRuleItemI[];
}

/**
 * @static 数据合法判断方法静态类
 */
class Validate {
  static reg(r: RegExp, value: any, msg: string) {
    if (!r.test(value)) throw new Error(msg);
  }

  static min(min: number, max: number, value: any, msg: string) {
    try {
      if (value.length > max || value.length < min) throw new Error(msg);
    } catch (err) {
      throw new Error(err);
    }
  }

  static required(value: any, msg: string) {
    if (value === undefined) throw new Error(msg);
    if (typeof value === 'string' && value.trim() === '') throw new Error(msg);
    if (Array.isArray(value) && Array.length === 0) throw new Error(msg);
    // return (typeof value === 'string' && value.trim() !== '') && true || value !== undefined && true;
  }
}

const validate = (value: any, rule: ValidateRuleItemI[]) => {
  let msg = '';
  try {
    rule.forEach((r) => {
      if (r.reg) {
        msg = r.message;
        Validate.reg(r.reg, value, r.message);
      } else if (r.min && r.max) {
        msg = r.message;
        Validate.min(r.min, r.max, value, r.message);
      } else if (r.required) {
        msg = r.message;
        Validate.required(value, r.message);
      }
    });
  } catch (err) {
    message.warning(msg);
    throw new Error(err);
  }
};

export default (form: Record<string, any>, rule: ValidateRuleI) => {
  try {
    console.log(Object.keys(form));
    return Object.keys(form).forEach((k) => {
      if (rule[k]) validate(form[k], rule[k]);
    });
  } catch (err) {
    throw new Error(err);
  }
};
